// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__CSM07","box":"style_box__dT8pk","active":"style_active__zvTlO","title":"style_title__aFIZm","item":"style_item__X3TUM"};